import classnames from 'classnames/bind'
import { GlobalTextPreset } from '~/@types/text-preset'

import SideNavigation from '~/components/Navigation/SideNavigation'
import TwoColumnsLayout, {
  TwoColumnsLayoutsTypes,
} from '~/components/UI/TwoColumnsLayout'

import { useStyle } from '~/providers/StyleProvider'

import { LegalPrivacySupportPageProps } from '~/data/legal-privacy-support-page-data/serializer'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type SideNavTwoColumnsContentProps = LegalPrivacySupportPageProps & {
  className?: string
  index?: number
}

function SideNavTwoColumnsContent({
  className,
  mainNavigation,
  rows,
  title,
  index,
}: SideNavTwoColumnsContentProps) {
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title24SangBleuLight,
  })

  const leftColumn = [
    mainNavigation?.length > 0 ? (
      <SideNavigation
        key="left_column_item"
        className={cx(css.sideNavigation)}
        links={mainNavigation}
        sliceIndex={index}
      />
    ) : title ? (
      <h1 key="left_column_item" className={cx(css.title, titleStyle)}>
        {title}
      </h1>
    ) : null,
  ]

  return (
    <div className={cx(css.SideNavTwoColumnsContent, className)}>
      <TwoColumnsLayout
        leftColumnComponents={leftColumn}
        rightColumnComponents={rows}
        layout={TwoColumnsLayoutsTypes.THIRDS}
      />
    </div>
  )
}

SideNavTwoColumnsContent.defaultProps = {}

export default SideNavTwoColumnsContent
